import React from "react";
import { Link } from "react-router-dom";
import "./PrintInformation.css";

export default function PrintInformation() {
  return (
    <main className="print-info-page">
      <header className="print-info-header">
        <div>
          <h1>PRINT INFORMATION</h1>
        </div>

        <Link to="/prints">← PRINTS</Link>
      </header>

      <section className="print-info-list">
        <article>
          <span></span>

          <div>
            <h2>THE PRINT</h2>

            <p>
              Each photograph is produced as a fine-art print using archival
              photographic materials selected for longevity and image quality.
            </p>
          </div>
        </article>

        <article>
          <span></span>

          <div>
            <h2>PAPER</h2>

            <p>
              Prints are available on carefully selected archival papers. The
              available paper options are listed with each photograph.
            </p>
          </div>
        </article>

        <article>
          <span></span>

          <div>
            <h2>EDITION</h2>

            <p>
              Unless otherwise specified, photographs are offered as open
              editions.
            </p>
          </div>
        </article>

        <article>
          <span></span>

          <div>
            <h2>PRODUCTION</h2>

            <p>
              Prints are made to order. Please allow approximately 2–3 weeks for
              production before shipment.
            </p>
          </div>
        </article>

        <article>
          <span></span>

          <div>
            <h2>SHIPPING</h2>

            <p>
              Prints are carefully packaged and shipped once production is
              complete. Shipping costs are calculated during checkout.
            </p>
          </div>
        </article>
      </section>
    </main>
  );
}
